import { notiIcon } from '@/shared/ui/assets';
import { RadioGroup } from '@/shared/ui/components';
import { Switch } from 'antd';
import { t } from 'ttag';
import { OPTIONS_SIGNATURE } from './createReturnShippingSignature.constants';
import type { CreateReturnShippingSignatureProps } from './createReturnShippingSignature.types';
import './createReturnShippingSignature.scss';

const CreateReturnShippingSignature = ({
  signatureConfirmation,
  onChangeOptionSignature,
  onChangeSignature,
}: CreateReturnShippingSignatureProps) => (
  <div className="create-return-shipping-signature">
    <div className="signature__header">{t`Signature confirmation`}</div>
    <div className="signature__checkbox">
      <Switch
        id="signature-confirmation-toggle"
        {...({ width: 34, height: 18 } as any)}
        checked={Boolean(signatureConfirmation)}
        onChange={onChangeSignature}
        aria-label={t`Signature confirmation`}
      />
      <div className="signature__label">
        {signatureConfirmation ? t`Required` : t`Not required`}
      </div>
    </div>
    {signatureConfirmation ? (
      <div className="signature__option">
        <div className="text">{t`Signed option`}</div>
        <RadioGroup
          options={OPTIONS_SIGNATURE}
          direction="vertical"
          size="small"
          className="custom-radio-group"
          value={signatureConfirmation}
          onChange={onChangeOptionSignature}
        />
        <div className="warning">
          <img src={notiIcon} alt="icon noti" />
          {t`The cost comes from the carrier and will be included in your selected rate.`}
        </div>
      </div>
    ) : null}
    <div className="signature__desc">
      {t`Common reasons a signature could be required upon delivery:`}
      <ul className="signature__list" aria-label={t`Reasons a signature could be required`}>
        <li className="signature__item">{t`To insure specific items like laptops a signature is required`}</li>
        <li className="signature__item">
          {t`To ship some regulated items like alcohol a signature is required from a legal adult`}
        </li>
        <li className="signature__item">
          {t`Additional security. Requiring a signature confirmation can give peace of mind`}
        </li>
      </ul>
    </div>
  </div>
);

export default CreateReturnShippingSignature;
